<template>
  <article class="question">
    <p class="text">{{ question }}</p>
    <div class="options">
      <button
        @click="onSelectOption(option.id)"
        :class="{active: active === option.id}"
        class="option-btn"
        v-for="option in options"
        :key="option.id"
      >
        {{ option.description }}
      </button>
    </div>
  </article>
</template>

<script>
export default {
  props: ['value', 'question', 'options', 'active'],
  methods: {
    onSelectOption(id) {
      this.$emit('input', id);
    },
  },
};
</script>

<style scoped lang="scss">
@import './question.scss';

.options {
  display: flex;
  align-items: center;
  justify-content: center;
}

.option-btn {
  white-space: nowrap;
  border: 1px solid #c5c3c3;
  box-sizing: border-box;
  border-radius: 4px;
  padding: 7px 12px;
  background: none;

  font-style: normal;
  font-weight: 400;
  font-size: 10px;
  line-height: 140%;
  text-align: center;
  color: #c5c3c3;

  cursor: pointer;
}

.option-btn:hover {
  color: #6e6e6e;
  background: #e8e8e8;
  border: 1px solid #e8e8e8;
}

.option-btn.active {
  background: var(--recommendations-primary, #e9a43d);
  border: 1px solid var(--recommendations-primary, #e9a43d);
  color: #333333;
}

.option-btn + .option-btn {
  margin-left: 10px;
}
</style>
